// extracted by mini-css-extract-plugin
module.exports = {"picker":"styles__picker___1eY5s","charLimit":"styles__charLimit___1OTcj"};